import { render, staticRenderFns } from "./ProductTileColors.vue?vue&type=template&id=2e902b51&"
import script from "./ProductTileColors.vue?vue&type=script&lang=js&"
export * from "./ProductTileColors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports